import { makeAutoObservable } from 'mobx';
import { RootStore } from './rootStore';
import { HotelConfig, getConfig } from '../apiMethods/getConfig';

export class HotelConfigStore {
  root: RootStore;
  config: HotelConfig | undefined;

  constructor(rootStore: RootStore) {
    this.root = rootStore;

    makeAutoObservable(this);
  }

  init() {
    this.loadConfig();
  }

  setConfig(config: HotelConfig) {
    this.config = config;
  }

  async loadConfig() {
    const config = await getConfig();
    config && this.setConfig(config);
  }

  get hasPromocode() {
    return this.config?.promo_code;
  }

  get hotelId() {
    return this.config?.id;
  }

  get rulesOfPurchase() {
    return this.config?.rules_purchasing_voucher;
  }

  get corpDescription() {
    return this.config?.corp_flow_description;
  }

  get specDescription() {
    return this.config?.spec_flow_description;
  }

  get childCategories() {
    return this.config?.hotel_child_categories.map(x => ({
      id: x.id,
      code: x.code,
      count: 0,
      use_in_calc: x.use_in_culc,
    }));
  }

  get paymentMethods() {
    if (this.root.paramsStore.nightsCount === 1) {
      // да, окончание на *gth, такое значение приходит с сервера
      const FIRST_NIGHT_PAYMENT_ALIAS = 'FIRST_NIGTH';
      return this.config?.hotel_payment_methods.filter(
        pm => pm.payment_alias !== FIRST_NIGHT_PAYMENT_ALIAS,
      );
    }
    return this.config?.hotel_payment_methods;
  }

  get policyLink() {
    const isOpenRate = this.root.paramsStore.rateMode === 'OPEN';
    if (isOpenRate) {
      return this.config?.users_term_open_rate;
    }
    return this.config?.users_term;
  }

  get rulesAndServicesLink() {
    const isOpenRate = this.root.paramsStore.rateMode === 'OPEN';
    if (isOpenRate) {
      return this.config?.rules_and_services_open_rate;
    }
    return this.config?.rules_and_services;
  }

  get shoudSkipServices() {
    return !this.config?.use_packages;
  }

  get bookingCancelTypes() {
    return this.config?.hotel_reservation_cancel_types;
  }

  get commentNoteId() {
    return this.config?.default_note;
  }

  get commentNoteCode() {
    return this.config?.note;
  }
}
